import { FormSchemaModelMapper } from '@cak-legacy/generation-schema-core';
import { ApplicationPathContextProvider } from '@cak-legacy/pilet-core';
import { GenericRekenmodule } from '@cak-legacy/shared-generic-rekenmodule';
import * as React from 'react';
import { ResultPage } from '../components/ResultPage';
import { IFlowSteps, IForm } from '../form/interface/form';
import { parsedHtmlElement } from '../form/interface/formContentData';
import { convertToSchema } from '../form/mapper/FlowstepMapper';
import { StepCategoryIndicator } from '../form/steps/StepCategoryIndicator';
import { getAllPageFlowSteps } from '../form/utils/pageflowStepHelper';
import { IFormProps } from '../interfaces';

export interface IDefaultValues {
  [key: string]: {
    [key: string]: unknown;
  };
}

export interface IFormulierContainerProps extends IFormProps {
  formJsonSchema: IForm;
  thankYouPageContent?: parsedHtmlElement;
  downloadInformationContent?: parsedHtmlElement;
}

export const FormulierContainer = (props: IFormulierContainerProps) => {
  const flowSteps: IFlowSteps[] = props.formJsonSchema.form.flowSteps;

  const jsonSchemaMapper = new FormSchemaModelMapper('');
  const startFlowStep = convertToSchema(flowSteps, jsonSchemaMapper);
  startFlowStep.isReadOnly = true;
  const allFlowSteps = getAllPageFlowSteps(startFlowStep);
  const availableCategories = allFlowSteps.map((step) => step.categoryName);
  const allFlowCategories = availableCategories.slice(0, -1);

  let pageBaseUrl = props.pageBaseUrl;
  if (props.pageBaseUrl.startsWith('/')) {
    pageBaseUrl = props.pageBaseUrl.substring(1);
  }

  return (
    <ApplicationPathContextProvider value={`${props.basePath}/${pageBaseUrl}`}>
      <div className="klantondersteuning-form-page-container">
        <GenericRekenmodule
          rekenmoduleTitle={props.formJsonSchema.form.title}
          moduleUrlPart={pageBaseUrl}
          showTitleOnResultPage={true}
          finalFlowCategoryTitle={'Resultaat'} // Dit is niet relevant voor klantondersteuning formulieren
          availableCategories={availableCategories}
          pageBaseUrl={props.basePath}
          apiBaseUrl={props.apiUrl}
          renderStepCategoryIndicator={(flowCategories: string[], showAllAsFinished: boolean) => (
            <StepCategoryIndicator
              flowCategories={flowCategories}
              allFlowCategories={allFlowCategories}
              showAllAsFinished={showAllAsFinished}
            />
          )}
          startFlowStep={startFlowStep}
          renderResultPage={(values: { [key: string]: unknown }, _onStartOver: () => void) => (
            <ResultPage
              values={values}
              apiUrl={props.apiUrl}
              language={props.language}
              formulierKenmerk={props.formulierKenmerk}
              pageFlowSteps={allFlowSteps}
              onderwerp={props.formJsonSchema.form.title}
              thankYouPageContent={props.thankYouPageContent}
              downloadInformationContent={props.downloadInformationContent}
              overzichtPath={props.overzichtPath}
              pageBaseUrl={pageBaseUrl}
              onSubmit={props.onSubmit}
              requestInformation={props.requestInformation}
              handleSubmit={props.handleSubmit}
              schemaToRequestMapper={props.schemaToRequestMapper}
            />
          )}
          defaultValues={props.defaultValues}
          flowSteps={allFlowSteps || []}
          datasources={[]}
          variables={{}}
        />
      </div>
    </ApplicationPathContextProvider>
  );
};
